import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import AnnualPropertyExpense from "./Child/RentAndExpense/AnnualPropertyExpense";
import { IAnalysedProperty } from "../../../interface/addAnalyser";
import AnnualRentalReturn from "./Child/RentAndExpense/AnnualRentalReturn";

interface IRentAndExpense {
  setIsValid: (isValid: boolean) => void;
  updateProperty: (updated: Partial<IAnalysedProperty>) => void;
}

const RentAndExpense = forwardRef<{ validate: () => boolean }, IRentAndExpense>(
  ({ setIsValid, updateProperty }, ref) => {
    const [totalRentalReturn, setTotalRentalReturn] = useState<number>(0);
    const rentAndExpenseRef = useRef<any>(null);

    useImperativeHandle(ref, () => ({
      validate: () => {
        if (rentAndExpenseRef.current) {
          return rentAndExpenseRef.current.validate();
        }
        return false;
      },
    }));

    return (
      <div className="flex flex-col gap-3">
        <AnnualRentalReturn
          ref={rentAndExpenseRef}
          setIsValid={setIsValid}
          updateProperty={updateProperty}
          updateRentalReturn={setTotalRentalReturn}
        ></AnnualRentalReturn>
        <AnnualPropertyExpense
          setIsValid={setIsValid}
          updateProperty={updateProperty}
          rentalReturnTotal={totalRentalReturn}
        ></AnnualPropertyExpense>
      </div>
    );
  }
);

export default RentAndExpense;
